import { gql } from '@apollo/client';

export interface ResolveHubspotDealRequest {
  id: string;
  organizationId?: string;
}

export interface ResolveHubspotDealResponse {
  resolveHubspotDeal: {
    id: string;
  };
}

export const RESOLVE_HUBSPOT_DEAL = gql`
  mutation resolveHubspotDeal($id: String!, $organizationId: String) {
    resolveHubspotDeal(id: $id, organizationId: $organizationId) {
      id
      organizationId
    }
  }
`;
